module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h4 class="attach-header"></h4>\n\n<div class="content-region" />\n\n<div class="actions">\n    <div class="notification-message pull-left" />\n    <button class="btn-ok-attach attach-button btn btn-primary pull-right ladda-button" data-spinner-size="28" data-style="expand-right">Attach<span class="ladda-spinner"></span></button>\n    <button class="btn-cancel-attach btn btn-secondary pull-right">Cancel</button>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/projects/AbstractProjectAttachView.tpl
// module id = 3092
// module chunks = 0